import { render } from "./CreateJobIndex.vue?vue&type=template&id=e936f068&scoped=true"
import script from "./CreateJobIndex.vue?vue&type=script&lang=js"
export * from "./CreateJobIndex.vue?vue&type=script&lang=js"

import "./CreateJobIndex.vue?vue&type=style&index=0&id=e936f068&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e936f068"]])

export default __exports__